var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "field is-flex is-justify-content-space-between" },
    [
      _c("small", { staticClass: "has-text-grey-light" }, [
        _vm._v(_vm._s(_vm.eligibilityParamText)),
      ]),
      _c(
        "span",
        {
          staticClass: "tag is-light is-rounded",
          class: _vm.eligibilityState.color,
        },
        [_vm._v(" " + _vm._s(_vm.eligibilityState.text) + " ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }